import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { colors, fontSizes } from '@/theme'
import config from '@/utils/config'
import { createFileRoute } from '@tanstack/react-router'

function Verify() {
    const router = useRouter();
    const { token } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch
    const [message, setMessage] = useState("");
    const [success, setSuccess] = useState<any>(null);

    const handleSubmit = async () => {

        const res = await fetch(config.managerHost + '/Authentication/VerifyToken', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'SC-Version': __APP_VERSION__
            },
            body: JSON.stringify({ Token: token })
        });

        const data = await res.text();
        const json = (data.length ? JSON.parse(data) : {});

        if (res.ok) {
            setMessage("");
            setSuccess(true);
        } else if (json && json.Message) {
            setMessage(`Failed to verify your email address. Reason: ${json.Message}`);
        } else if (json) {
            setMessage(`Failed to verify your email address. ${json}`);
            setSuccess(false);
        }
    };

    useEffect(() => {
        if (router.isReady && token) {
            handleSubmit();
        }
    }, [router.isReady, token]);

    return (
        <div className="login">
            <div className="container">
                <img src="/logo-type-blue.svg" alt="Login Logo" />
                <h1>Keep your work in one place</h1>

                <br /><br />
                <h2 className={`error ${success !== false ? "" : "error-display"}`}>{message}</h2>
                {success === true ? <>
                    <h2>You have successfully verified your email address. Proceed to <a className="link" href="/login">login page</a>.</h2>
                </> : ""}
                {success === null ? <>
                    <h2>Verifying your email address...</h2>
                </> : ""}

                <img className="wave" src="/login-wave.svg" alt="Login Wave" />
            </div>
            <style jsx>{`
        .login {
          display: flex;
          height: 100vh;
          justify-content: center;
          overflow: hidden;
          position: relative;
          width: 100%;
        }
        .container {
          color: #333;
          text-align: center;
          width: 50%;
        }
        img {
          padding-top: 3.5rem;
        }
        h1 {
          color: ${colors.blueGrey};
          font-size: 24px;
          margin: 0;
          padding-top: 1.5rem;
        }
        h2 {
          color: ${colors.darkPrimary};
          font-size: 24px;
          margin: 0;
          padding-top: 1.5rem;
        }
        p {
          color: ${colors.blueGrey};
          font-size: ${fontSizes.body};
          margin: 0;
          padding-bottom: 1rem;
          padding-top: 0.5rem;
        }
        .wave {
          bottom: 0;
          pointer-events: none;
          left: 0;
          min-width: 1300px;
          position: absolute;
          width: 100vw;
          z-index: -1;
        }
        .row {
          align-items: center;
          display: flex;
          justify-content: space-between;
          margin-top: 1rem;
        }
        .center {
          justify-content: center;
        }
        .end {
          justify-content: flex-end;
        }
        .row a,.row-center a {
          color: ${colors.bluePrimary};
          cursor: pointer;
          font-size: 0.875rem;
        }
        .error {
          color: ${colors.warningRed};
          display: none;
        }
        .error-display {
          display: block;
        }

        .link {
            color: ${colors.bluePrimary};
        }
      `}</style>
        </div>
    );
}

export default Verify;

export const Route = createFileRoute('/verify')({ component: Verify })
